/* @flow */
import * as React from "react";
import PropTypes from "prop-types";
import prefixStyles from "nx-components/utils/prefixStyles";
import Theme from "nx-components/Theme";
import DOMEventListener from "nexia_mobile/components/DOMEventListener";

const baseStyles = {
  wrapper: {
    flex: "none",
    transition: "opacity 100ms ease-in-out",
    position: "relative",
    height: "0",
    zIndex: Theme.zIndexLayers.CONTENTS + 1,
  },
};

const styles = prefixStyles({
  wrapperVisible: {
    ...baseStyles.wrapper,
    opacity: "1.0",
  },
  wrapperInvisible: {
    ...baseStyles.wrapper,
    opacity: "0.0",
  },
  inner: {
    backgroundColor: "transparent",
    backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.20), transparent)",
    position: "absolute",
    top: "0",
    height: "5px",
    width: "100%",
  },
});

type Props = {
  target: ?HTMLElement,
  ignoreSafeArea?: boolean,
};

type State = {
  isVisible: boolean,
};

export default class AppBarShadow extends React.Component<Props, State> {
  static contextTypes = {
    isLargeAppLayout: PropTypes.bool,
  };

  state = {
    isVisible: false,
  };

  _calculateVisibility = () => {
    const { target } = this.props;
    if (target == null) {
      this.setState({ isVisible: false });
      return;
    }

    const isVisible = target.scrollTop > 0;
    if (isVisible !== this.state.isVisible) {
      this.setState({ isVisible });
    }
  };

  render() {
    const { target, ignoreSafeArea } = this.props;
    const { isVisible } = this.state;
    const leftSafePadding = this.context.isLargeAppLayout
      ? "0px"
      : Theme.Padding.SAFE_AREA_LEFT;

    return (
      <div
        data-component-name="ScrollShadow"
        style={isVisible ? styles.wrapperVisible : styles.wrapperInvisible}
      >
        <div
          style={{
            ...styles.inner,
            ...(ignoreSafeArea
              ? null
              : {
                  width: `calc(100% + ${leftSafePadding} + ${Theme.Padding.SAFE_AREA_RIGHT})`,
                  marginLeft: `calc(-1 * ${leftSafePadding})`,
                }),
          }}
        >
          <DOMEventListener
            target={target}
            eventName="scroll"
            handler={this._calculateVisibility}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Scrollable/ScrollShadow.jsx